export enum AUTHENTICATION_TYPES {
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  AUTH_PENDING = 'pending',
}
